import { Button, Space } from 'antd';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import DrawerWithAutoWidth from '../../../../components/DrawerWithAutoWidth';
import UpdateAdyenPaymentModuleForm, { type FormValues } from './UpdateAdyenPaymentModuleForm';

type UpdateAdyenPaymentModuleDrawerProps = {
    moduleId: string;
    initialValues: FormValues;
    visible: boolean;
    onClose: () => void;
};

const UpdateAdyenPaymentModuleDrawer = ({
    moduleId,
    initialValues,
    visible,
    onClose,
}: UpdateAdyenPaymentModuleDrawerProps) => {
    const { t } = useTranslation(['adyenPaymentModuleDetails']);

    return (
        <DrawerWithAutoWidth
            extra={
                <Space>
                    <Button onClick={onClose}>{t('adyenPaymentModuleDetails:paymentModuleDrawer.cancelButton')}</Button>
                    <Button form="updateAdyenPaymentModule" htmlType="submit" type="primary">
                        {t('adyenPaymentModuleDetails:paymentModuleDrawer.submitButton')}
                    </Button>
                </Space>
            }
            onClose={onClose}
            title={t('adyenPaymentModuleDetails:paymentModuleDrawer.title.update')}
            visible={visible}
            destroyOnClose
        >
            <UpdateAdyenPaymentModuleForm initialValues={initialValues} moduleId={moduleId} onComplete={onClose} />
        </DrawerWithAutoWidth>
    );
};

export default UpdateAdyenPaymentModuleDrawer;

export const useUpdateAdyenPaymentModuleDrawer = (
    moduleId: string,
    initialValues: UpdateAdyenPaymentModuleDrawerProps['initialValues']
) => {
    const [visible, setVisible] = useState(false);

    const actions = useMemo(
        () => ({
            open: () => setVisible(true),
            close: () => setVisible(false),
        }),
        [setVisible]
    );

    return {
        ...actions,
        render: () => (
            <UpdateAdyenPaymentModuleDrawer
                initialValues={initialValues}
                moduleId={moduleId}
                onClose={actions.close}
                visible={visible}
            />
        ),
    };
};
